export default __webpack_public_path__ + "static/media/feed.e022ec8d.svg";